/**
 * PulseRepository — HTTP for the Layer-1 market-pulse strip
 * (`/api/v2/home/pulse`).
 *
 * Methods return the raw AxiosResponse; callers read `.data`. The reactive
 * store + refresh helpers live in `src/composables/pulse.js`.
 */
import AuthenticatedClient from './clients/AuthenticatedClient';
import Client from './clients/Client';

export default {
  /** @returns {Promise<import('axios').AxiosResponse>} */
  getPulse({ demo = false } = {}) {
    return demo ? Client.get('/home/pulse/demo') : AuthenticatedClient.get('/home/pulse');
  },
};
